export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Greek-8748d1f52ef2b74c59b39cfefb645f12.woff";